import { createAction } from "typesafe-actions";

import type { ICatalogTreeSlice } from "@/shop/types/catalog";

import type { CatalogFetchOptions, IShowVariantsSelection } from "./types";

export const fetchCatalog = createAction("CATALOG_FETCH_CATALOG", (options: CatalogFetchOptions) => options)();

export const fetchBaseCategories = createAction("CATALOG_FETCH_BASE_CATEGORIES", (options: CatalogFetchOptions) => options)();
export const setBaseCategories = createAction("CATALOG_SET_BASE_CATEGORIES", (payload: ICatalogTreeSlice[]) => payload)();

export const setCustomerSpecificCategories = createAction("CATALOG_SET-CUSTOMER_SPECIFIC_BASE_CATEGORIES", (payload: ICatalogTreeSlice[]) => payload)();

export const showVariantsSelection = createAction("CATALOG_SHOW_VARIANTS_SELECTION", (payload: IShowVariantsSelection) => payload)();
